const ViewObserverEvent = Object.freeze({
    VIEW_ENTER: 'viewenter'
});

const createViewEvent = eventName =>
    new CustomEvent(eventName, {
        bubbles: false,
        cancelable: false
    });

const handleViewObserver = entries => {
    entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
            const entryEvent = createViewEvent(ViewObserverEvent.VIEW_ENTER);
            ViewObserver.unobserve(entry.target);
            entry.target.dispatchEvent(entryEvent);
        }
    });
};

const options = {
    rootMargin: '0px',
    threshold: 0.5
};

const ViewObserver = new IntersectionObserver(handleViewObserver, options);

export { ViewObserver, ViewObserverEvent };
